import { QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED } from '../../../constants/qa'

export const LISTING_DRAFT_PREFIX = 'rental-portal-listing'

export const LISTING_MINIMIZED_REPLACE_CONFIRMATION = {
  description: 'RentalPortal.ListingMinimizedDraftSavedConfirmationTextKey',
  qaName: QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED,
}

export const QA_NAME_CONFIRMATION_LISTING_EDIT_MINIMIZED_REPLACE =
  'confirmationListingEditMinimizedReplace'

export const LISTING_EDIT_MINIMIZED_REPLACE_CONFIRMATION = {
  description: 'RentalPortal.ListingEditMinimizedReplaceConfirmationTextKey',
  qaName: QA_NAME_CONFIRMATION_LISTING_EDIT_MINIMIZED_REPLACE,
}

export const QA_NAME_LISTING_DRAFT_CREATE_ACTION_MODAL = 'listingDraftCreate'

export const QA_NAME_LISTING_DRAFT_CLOSE_ACTION_MODAL = 'listingDraftClose'
